var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBlueDownloadIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  id: "Union_15",
  "data-name": "Union 15",
  d: "M2.4,16A2.4,2.4,0,0,1,0,13.6V10.4a.8.8,0,1,1,1.6,0v3.2a.8.8,0,0,0,.8.8H13.6a.8.8,0,0,0,.8-.8V10.4a.8.8,0,1,1,1.6,0v3.2A2.4,2.4,0,0,1,13.6,16ZM8,11.2H7.922l-.018,0h0l-.018,0h0l-.018,0h0l-.017,0h0l-.014,0H7.825l-.01,0-.012,0h0a.79.79,0,0,1-.364-.208l-4-4A.8.8,0,0,1,4.566,5.834L7.2,8.469V.8A.8.8,0,0,1,8.8.8V8.469l2.634-2.634a.8.8,0,0,1,1.131,1.131l-4,4a.791.791,0,0,1-.364.208h0l-.012,0-.01,0H8.17l-.015,0h0l-.017,0h0l-.018,0h0l-.018,0h0l-.018,0H8Z",
  fill: "currentColor"
})));
export { SvgBlueDownloadIcon as ReactComponent };
export default __webpack_public_path__ + "static/media/BlueDownloadIcon.7ee4c65dd7cda7c04ee47bf03cd9370b.svg";